'use client';

import classNames from 'classnames';
import { memo } from 'react';

import { type Chapter } from './VideoSeekbar';

export type VideoSeekbarProgressChaptersProps = {
  chapters: Chapter[];
  duration: number;
  isFullscreen?: boolean;
};

export const VideoSeekbarProgressChapters = memo(
  ({ chapters, duration, isFullscreen = false }: VideoSeekbarProgressChaptersProps) => {
    return (
      <div className="pointer-events-none absolute inset-0 flex items-center">
        {chapters.map((chapter, index) => {
          if (index === 0) return null;

          const position = (chapter.startTime / duration) * 100;

          return (
            <div
              className={classNames('absolute z-10 h-1.5 w-1 -translate-x-1/2', {
                'bg-gray-1': !isFullscreen,
                'bg-gray-1/60': isFullscreen,
              })}
              key={chapter.startTime}
              style={{
                left: `${position}%`,
              }}
            />
          );
        })}
      </div>
    );
  },
);

VideoSeekbarProgressChapters.displayName = 'VideoSeekbarProgressChapters';
